module.exports = __webpack_public_path__ + "static/media/squared.bd81bccf.jpg";